import React , {Component} from 'react';

import './product-counter.css';


class ProductCounter extends Component{
    state={
        count:1
    }
    plusClick=()=>{
        this.setState(({count})=>{
            let num=isFinite(count) ? ++count : 1;
            this.update(num);
            return {
                count: num
            }
        });
    }
    minusClick=()=>{
        this.setState(({count})=>{
           
            let num=1;
            if(isFinite(count)){
                num=count>1 ? --count : 1;
            }
            
            this.update(num);
            return {
                count:num
            }
        });
    
    }
    counterChange=(e)=>{
        this.setState({count: e.target.value});
        this.update(e.target.value);
        
    }
    update=(val)=>{
        this.props.changeCount(val);
    }
    render(){
        let count=this.state.count;
        return(
            <div className="product-counter">
                <button 
                onClick={this.minusClick}
                className="btn-counter btn-minus">
                    <i className="fa fa-minus"></i>
                </button>
                <input
                onChange={this.counterChange}
                className="input-counter" value={count}/>
                
                <button 
                onClick={this.plusClick}
                className="btn-counter btn-plus">
                    <i className="fa fa-plus"></i>
                </button>
            </div>
        );
    }
}



export default ProductCounter;